export function isStingable(lastStungAt?: Date | null) {
  // user can sting if the last sting was more than 12 hours ago (or never)
  return (
    !lastStungAt || lastStungAt.getTime() < Date.now() - 12 * 60 * 60 * 1000
  )
}
